/**
 * v3.finance — WAVE-11 Finance form intake + unified My Requests view.
 *
 * Backed by Functions/FinanceFormsFunction.cs. Three intake POSTs +
 * one read-only aggregate GET. Per Bill 2026-04-26: v3 OWNS the storage;
 * SP-list writes do NOT happen from this client.
 */

import type {
  RequestOptions,
  RdaLimitIncreaseSubmitInput,
  B2bLimitIncreaseSubmitInput,
  DormantReleaseSubmitInput,
  FinanceFormSubmitResponse,
  MyRequestsListResponse,
} from '@retail-ops/shared-types';
import type { ApiHttpClient } from '../http.js';

export class FinanceApi {
  public constructor(private readonly http: ApiHttpClient) {}

  public submitRda(body: RdaLimitIncreaseSubmitInput, opts?: RequestOptions): Promise<FinanceFormSubmitResponse> {
    return this.http.post<FinanceFormSubmitResponse>('/v3/finance/rda-limit-increase', { ...opts, body });
  }

  public submitB2b(body: B2bLimitIncreaseSubmitInput, opts?: RequestOptions): Promise<FinanceFormSubmitResponse> {
    return this.http.post<FinanceFormSubmitResponse>('/v3/finance/b2b-limit-increase', { ...opts, body });
  }

  public submitDormant(body: DormantReleaseSubmitInput, opts?: RequestOptions): Promise<FinanceFormSubmitResponse> {
    return this.http.post<FinanceFormSubmitResponse>('/v3/finance/dormant-release', { ...opts, body });
  }

  public myRequests(
    filters: { upn?: string; status?: string; type?: string; top?: number } = {},
    opts?: RequestOptions,
  ): Promise<MyRequestsListResponse> {
    return this.http.get<MyRequestsListResponse>('/v3/finance/my-requests', {
      ...opts,
      query: filters as unknown as Record<string, string | number | boolean | undefined>,
    });
  }
}
